import { Component, EventEmitter, Injectable, Input, Output } from '@angular/core';
import { tap } from 'rxjs';
import { RegistrationList } from 'src/app/components/registration-list/registration-list.model';
import { ResponseModel } from '../../models/response-model.model';
import { DataService } from '../../services/data.service';
import { StorageService } from '../../services/storage.service';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ],
})
export class InputComponent {
  @Input() inputType:string='text';
  @Input() inputName:string;
  @Input() inputPlaceholder:string='';
  @Input() inputLabel:string;
  @Input() inputId:string;
  @Input() inputValue:string='';
  @Input() isRequired:boolean;
  @Input() inputMaxlength:boolean=false;
  @Input() inputClass:string='';
  @Input() disabled :boolean;
  @Input() readOnly: boolean=false;
  @Input() maxDate:string;
  @Input() minDate:string;
  @Input() max:any;
  @Input() min:any;
  @Input() isEyeIconShow:false;
  @Input() isPassPattern:boolean=false;
  @Input() customClass!: string;
  @Input() astricShow:boolean=false;
  @Input() focusInputOtp:boolean = false;
  @Input() maxLength:any;
  @Input() minLength:any;
  @Input() isOnPaste? : boolean = false;
  @Input() isOtpInput? : boolean = false;
  @Input() onlyNumbers: boolean = false; // Default to false, indicating no onlyNumbers directive by default
  @Input() allowDecimal: boolean = false;
  @Input() decimalPlaces: number = 0;
  @Output() inputValueEmit:EventEmitter<string> = new EventEmitter();
  @Output() keydownEmit:EventEmitter<string> = new EventEmitter();
  @Output() inputBlur = new EventEmitter<void>();
  @Output() onPaste:EventEmitter<any> = new EventEmitter();
  public show: boolean = false;
  public pattern: string;
  public passwordPattern: string = '^(?=.*[a-zA-Z])(?=.*\\d)(?=.*[@$!%*?&])[a-zA-Z\\d@$!%*?&]{8,}$';
  public passPattern = "^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[@#$%^&*_!])[A-Za-z0-9@#$%^&*_!]{8,}.*$";
  //public emailPattern: string = "[-a-zA-Z0-9~!$%^&amp;*_=+}{'?]+(\.[-a-zA-Z0-9~!$%^&amp;*_=+}{'?]+)*@([a-zA-Z0-9_][-a-zA-Z0-9_]*(\.[-a-zA-Z0-9_]+)*\.([cC][oO][mM]))(:[0-9]{1,5})?";
  public emailPattern: string = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$";
  ngOnInit(): void {
    this.isEnablePattern();
  }

  showHidePass(){
    this.show = !this.show;
    if(this.show){
      this.inputType = 'text';
    }
    else{
      this.inputType = 'password';
    }
  }

  isEnablePattern(): void {
    if (this.inputName === 'email') {
      this.pattern = this.emailPattern;
    } else if (this.inputName === 'password') {
      this.pattern = this.passwordPattern;
    } else {
      this.pattern = null;
    }
  }

  focusInput(event) {
    if (this.focusInputOtp) {
      const inputField = document.getElementById(event?.target?.id) as HTMLInputElement;
      inputField.select();
    }
  }

  
}